import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMenu, FiUser, FiSun, FiMoon, FiMonitor, FiLogOut, FiSettings } from 'react-icons/fi';
import { useTheme } from '../../App';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import './Header.css';

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { theme, cycleTheme } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const getThemeIcon = () => {
    switch(theme) {
      case 'light':
        return <FiSun />;
      case 'dark':
        return <FiMoon />;
      default:
        return <FiMonitor />;
    }
  };

  const getThemeLabel = () => {
    switch(theme) {
      case 'light':
        return 'Light';
      case 'dark':
        return 'Dark';
      default:
        return 'Auto';
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully');
      navigate('/login');
    } catch (error) {
      toast.error('Logout failed');
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleSettingsClick = () => {
    setShowDropdown(false);
    navigate('/settings');
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onToggleSidebar}>
          <FiMenu />
        </button>
      </div>

      <div className="header-right">
        <button 
          className="header-btn theme-btn"
          onClick={cycleTheme}
          title={`Theme: ${getThemeLabel()}`}
        >
          {getThemeIcon()}
        </button>
        
        <div className="user-menu">
          <button className="header-btn user-btn" onClick={toggleDropdown}>
            <FiUser />
            <span className="user-name-header">{user?.username || 'User'}</span>
          </button>
          
          {showDropdown && (
            <>
              <div className="dropdown-overlay" onClick={() => setShowDropdown(false)} />
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="user-info">
                    <div className="user-avatar">
                      <FiUser />
                    </div>
                    <div className="user-details">
                      <span className="user-name">{user?.username}</span>
                      <span className="user-email">{user?.email || 'No email set'}</span>
                      <span className="user-role">{user?.role === 'admin' ? 'Administrator' : 'User'}</span>
                    </div>
                  </div>
                </div>
                
                <div className="dropdown-divider"></div>
                
                <button className="dropdown-item" onClick={handleSettingsClick}>
                  <FiSettings /> Settings
                </button>
                
                <button className="dropdown-item logout-item" onClick={handleLogout}>
                  <FiLogOut /> Logout
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
